import { addAlpha } from 'styles/utils';

const scheduleBtnPaddingX = 40;
const cardActionSize = 45;
const outerRadius = 12;
const borderWidth = 2;

export default ({ theme }) => ({
  '&.cardRoot': {
    position: 'relative',
    width: '100%',
    border: `${borderWidth}px solid ${theme.palette.primary.light}`,
    flexDirection: 'column',
    alignItems: 'initial',
    justifyContent: 'initial',
    borderRadius: outerRadius,
    transition: 'box-shadow 300ms linear',
    backgroundColor: theme.palette.background.paper,
    '&:hover, &:focus': {
      boxShadow: `0 10px 20px 0 ${theme.palette.background.paper}`,
      '& .card__company': {
        visibility: 'hidden',
        [theme.breakpoints.down('desktopApp')]: {
          visibility: 'visible',
        },
      },
      '& .card__actions': {
        '&.card__actions_default': {
          display: 'flex',
          '& .card__action': {
            '&:nth-of-type(1)': {
              animation:
                'fadeInY 300ms cubic-bezier(0, 0, 0, 0.54) 100ms forwards',
              [theme.breakpoints.down('desktopApp')]: {
                animation: 'none',
              },
            },
            '&:nth-of-type(2)': {
              animation:
                'fadeInY 300ms cubic-bezier(0, 0, 0, 0.54) 300ms forwards',
              [theme.breakpoints.down('desktopApp')]: {
                animation: 'none',
              },
            },
            '&:nth-of-type(3)': {
              animation:
                'fadeInY 300ms cubic-bezier(0, 0, 0, 0.54) 500ms forwards',
              [theme.breakpoints.down('desktopApp')]: {
                animation: 'none',
              },
            },
          },
          [theme.breakpoints.down('desktopApp')]: {
            display: 'none',
          },
        },
      },
    },
    [theme.breakpoints.down('desktopApp')]: {
      // minHeight: 'auto',
      height: '100%',
      boxShadow: `0 6px 16px 0 ${addAlpha(
        theme.palette.common.white,
        0.1,
      )}`,
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
  },
  '& .bestFitLabel': {
    position: 'absolute',
    left: -27,
    top: 25,
    zIndex: 10,
    padding: '5px 16px',
    transform: 'rotateZ(90deg)',
    transformOrigin: 'bottom left',
    fontSize: 11,
    fontWeight: 'bold',
    color: theme.palette.common.white,
    boxShadow: '4px 2px 6px rgb(0 0 0 / 50%)',
    borderBottom: '2px solid #b2aef5',
    letterSpacing: 1.25,
    borderBottomLeftRadius: 3,
    borderBottomRightRadius: 3,
    backgroundColor: theme.palette.tertiary.dark,
    backgroundImage: `radial-gradient(${theme.palette.tertiary.light} 20%, transparent 20%), radial-gradient(${theme.palette.tertiary.light} 20%, transparent 20%)`,
    backgroundPosition: '0 0, 2.5px 2.5px',
    backgroundSize: '5px 5px',
    '&::after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      right: -2,
      zIndex: -1,
      background: theme.palette.background.paper,
      width: 4,
      height: '100%',
      borderRadius: '50%',
    },
  },
  '& .card__content': {
    width: '100%',
    minHeight: 388,
    display: 'flex',
    [theme.breakpoints.down('desktopApp')]: {
      minHeight: 'auto',
      // height is calculated in Deck
      height: 'inherit',
      flex: 1,
    },
  },
  '& .footer__placeholder': {
    width: '100%',
    height: 80,
  },
  '& .card__actions': {
    position: 'absolute',
    left: 3,
    right: 3,
    bottom: 3,
    padding: '60px 18px 25px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: 'none',
    borderRadius: '0 0 16px 16px',
  },
  '& .card__actions_default': {
    display: 'none',
  },
  '& .card__actions_withSchedule': {
    paddingTop: 10,
    display: 'flex',
    flexDirection: 'column',
    '& .card__action': {
      '&:nth-of-type(1), &:nth-of-type(2)': {
        transform: 'translateY(0px) translateX(40px)',
        zIndex: -1,
      },
    },
    '& .actions__container': {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      '& .actions__innerContainer': {
        display: 'flex',
        '& > span:nth-of-type(1) > button.card__action': {
          left: 10,
        },
        '& > span:nth-of-type(2) > button.card__action': {
          left: 105,
        },
        '& .card__action': {
          position: 'absolute',
          zIndex: -1,
          '&:nth-of-type(1)': {
            left: scheduleBtnPaddingX,
          },
          '&:nth-of-type(2)': {
            left: '50%',
            transform: 'translateX(-50%)',
            marginLeft: 0,
          },
        },
      },
      '& .actions__innerContainer_qa': {
        display: 'flex',
        '& > span:nth-of-type(1) > button.card__action': {
          left: 0,
        },
        '& > span:nth-of-type(2) > button.card__action': {
          left: 70,
        },
        '& > span:nth-of-type(3) > button.card__action': {
          // quick apply button
          left: 140,
        },
        '& .card__action': {
          position: 'absolute',
          zIndex: -1,
          '&:nth-of-type(1)': {
            left: scheduleBtnPaddingX,
          },
          '&:nth-of-type(2)': {
            left: '50%',
            transform: 'translateX(-50%)',
            marginLeft: 0,
          },
        },
        '& .tipQa': {
          left: 140,
          transform: 'translateX(150)',
        },
      },
      '&:hover, &:focus': {
        '& .actions__innerContainer, .actions__innerContainer_qa':
          {
            '& .card__scheduleBtn': {
              boxShadow: 'none',
              animation: 'toggleIn 300ms linear forwards',
              '& .scheduleBtnTitle': {
                visibility: 'hidden',
                opacity: 0,
                maxWidth: 0,
                transition: 'all 0s linear 0.2s',
                [theme.breakpoints.down('desktopApp')]: {
                  display: 'initial',
                },
              },
              [theme.breakpoints.down(theme.desktopBreakPoint)]:
                {
                  boxShadow: `0 0 10px 0 ${addAlpha(
                    theme.palette.common.white,
                    0.2,
                  )}`,
                  animation: 'none',
                },
            },
            '& .card__action': {
              '&:nth-of-type(1)': {
                animation:
                  'fadeInX 200ms cubic-bezier(0, 0, 0, 0.54) 200ms forwards',
                zIndex: 100,
                [theme.breakpoints.down('desktopApp')]: {
                  animation: 'none',
                },
              },
              '&:nth-of-type(2)': {
                animation:
                  'fadeInXCentered 200ms cubic-bezier(0, 0, 0, 0.54) 400ms forwards',
                zIndex: 100,
                [theme.breakpoints.down('desktopApp')]: {
                  animation: 'none',
                },
              },
            },
          },
      },
    },
  },
  '& .actions__innerContainer, .actions__innerContainer_qa': {
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('desktopApp')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  '& .card__action': {
    opacity: 0,
    transform: 'translateY(40px)',
    '&.card__scheduleBtn': {
      // opacity: 1,
      // transform: 'translateY(0px)',
    },
    '&:not(.card__scheduleBtn)': {
      [theme.breakpoints.down('desktopApp')]: {
        display: 'none',
      },
    },
  },
  '@keyframes fadeInY': {
    '100%': {
      opacity: 1,
      transform: 'translateY(0px)',
    },
  },
  '@keyframes fadeInX': {
    '100%': {
      opacity: 1,
      transform: 'translateX(0px)',
    },
  },
  '@keyframes fadeInXCentered': {
    '100%': {
      opacity: 1,
      transform: 'translateX(-50%)',
    },
  },
  '@keyframes toggleIn': {
    '0%': {
      padding: `0 ${scheduleBtnPaddingX}px`,
    },
    '100%': {
      padding: 0,
      right: -25,
      width: cardActionSize,
    },
  },
  '@keyframes toggleOut': {
    '0%': {
      padding: 0,
      right: 0,
      width: cardActionSize,
    },
    '100%': {
      padding: `0 ${scheduleBtnPaddingX}px`,
    },
  },
  '& .card__scheduleBtnContainer': {
    position: 'relative',
    width: 260,
    height: cardActionSize,
    marginLeft: -scheduleBtnPaddingX,
    [theme.breakpoints.down('desktopApp')]: {
      marginLeft: 0,
    },
  },
  '& .card__scheduleBtn': {
    position: 'absolute',
    top: 0,
    right: -scheduleBtnPaddingX,
    zIndex: 100,
    width: '100%',
    height: cardActionSize,
    padding: `0 ${scheduleBtnPaddingX}px`,
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontWeight: 'bold',
    fontSize: 9,
    lineHeight: '10px',
    boxShadow: theme.palette.primary.contrastTextTransparent,
    animation: 'toggleOut 300ms linear forwards',
    [theme.breakpoints.down('desktopApp')]: {
      position: 'static',
      maxWidth: 300,
      height: 55,
      animation: 'none',
    },
  },
  '& .scheduleBtnTitle': {
    visibility: 'visible',
    opacity: 1,
    maxWidth: 113,
    transition: 'all 0s linear 0.3s',
  },
  '& .scheduleBtnIconWrapper': {
    minWidth: cardActionSize,
    height: cardActionSize,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& .schedule__title': {
    marginBottom: 12,
    fontWeight: 'bold',
    fontSize: 10,
    lineHeight: '12px',
    color: theme.palette.grey['300'],
  },
  '& .card__btn': {
    width: '100%',
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'normal',
    justifyContent: 'flex-start',
    borderRadius: outerRadius - borderWidth,
  },
  '&.card__applied': {
    border: '3px solid',
    borderColor: theme.palette.success.main,
  },
  '& .card__photoArea': {
    position: 'relative',
    height: 160,
    width: '100%',
    margin: '0 0 32px',
    alignSelf: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundColor: `${addAlpha(
      theme.palette.common.white,
      0.2,
    )}`,
    borderRadius: outerRadius - borderWidth,
    [theme.breakpoints.down('desktopApp')]: {
      minHeight: 80,
      maxHeight: 400,
      height: 'calc(100vh - 550px)',
      margin: '4px 4px 0',
    },
  },
  '& .card__ratingContainer': {
    position: 'absolute',
    left: '50%',
    bottom: 0,
    transform: 'translateX(-50%)',
    minWidth: 160,
    padding: '9px 9px 7px',
    display: 'inline-flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: 10,
    lineHeight: '12px',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.background.default,
    borderRadius: '4px 4px 0 0',
    [theme.breakpoints.down('desktopApp')]: {
      minWidth: 155,
      padding: 11,
      fontSize: 11,
      lineHeight: '12px',
    },
  },
  '& .card__ratingDelimiter': {
    color: theme.palette.grey['700'],
  },
  '& .card__mainContent': {
    flex: 1,
    // padding: '7px 8px 18px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('desktopApp')]: {
      // padding: '12px 10px 21px'
    },
  },
  '& .card__name': {
    marginBottom: 5,
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: 17,
    lineHeight: '19px',
    letterSpacing: 0,
    color: theme.palette.grey['100'],
    [theme.breakpoints.down('desktopApp')]: {
      marginBottom: 6,
      fontSize: 24,
      lineHeight: '27px',
    },
  },
  '& .card__employerContacts': {
    marginBottom: 12,
    textAlign: 'left',
    fontWeight: 700,
    fontSize: 12,
    lineHeight: '150%',
    color: theme.palette.primary.light,
  },
  '& .card__employerAddress': {
    // color: theme.palette.primary.light
  },
  // card__jobStats: {
  //   marginBottom: 18,
  //   display: 'flex',
  //   alignItems: 'center',
  //   fontWeight: 'bold',
  //   fontSize: 14,
  //   lineHeight: '17px',
  //   letterSpacing: 0,
  //   color: theme.palette.common.white,
  //   [theme.breakpoints.down('desktopApp')]: {
  //     marginBottom: 16,
  //     fontSize: 16,
  //     lineHeight: '17px',
  //   }
  // },
  '& .navIcon': {
    display: 'inline-block',
    paddingLeft: 9,
    paddingRight: 5,
    verticalAlign: 'text-bottom',
  },
  '& .card__jobDescription': {
    textAlign: 'left',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '150%',
    letterSpacing: 0,
    color: theme.palette.common.white,
    [theme.breakpoints.down('desktopApp')]: {
      marginBottom: 16,
    },
  },
  '& .card__company': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .card__companyLogo': {
    height: 48,
    minWidth: 48,
    border: '0.5px solid rgba(255,255,255,0.1)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundColor: 'rgba(255,255,255,0.1)',
    borderRadius: '50%',
  },
  '& .card__companyName': {
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: 0,
    [theme.breakpoints.down('desktopApp')]: {
      fontSize: 14,
      lineHeight: '17px',
    },
  },
  '& .status': {
    position: 'absolute',
    top: 12,
    left: 12,
    height: 32,
    padding: '0 12px',
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    lineHeight: '17px',
    borderRadius: 16,
    backgroundColor: theme.palette.background.default,
    transition: 'background-color .25s ease-out',
    '&.applied': {
      color: theme.palette.primary.contrastText,
      background: theme.palette.success.main,
    },
    '&.rejected': {
      color: theme.palette.success.main,
    },
    [theme.breakpoints.down('desktopApp')]: {
      display: 'none',
    },
  },
  '& .status__icon': {
    marginRight: 6,
  },
  '& .mobileScheduleModal__header': {
    padding: '20px 18px 8px',
    paddingRight: 24,
    display: 'flex',
    alignItems: 'flex-start',
  },
  '& .mobileScheduleModal__title': {
    marginBottom: 11,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: '16px',
    color: theme.palette.grey['100'],
  },
  '& .mobileScheduleModal__subTitle': {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 11,
    lineHeight: '15px',
    color: theme.palette.primary.light,
  },
  '& .mobileScheduleModal__confirmTitle': {
    marginBottom: 8,
    fontWeight: 'bold',
    fontSize: 11,
    lineHeight: '12px',
    color: theme.palette.grey['100'],
  },
  '& .mobileScheduleModal__confirmDate': {
    marginBottom: 25,
    fontWeight: 'bold',
    fontSize: 13,
    lineHeight: '14px',
    color: theme.palette.primary.light,
  },
  '& .scheduleModal': {
    width: '100%',
    maxWidth: 400,
  },
  '& .shareButton': {
    position: 'absolute',
    right: 10,
    top: 10,
    zIndex: 100,
    width: 35,
    height: 35,
    fontSize: 18,
  },
});
